export function chooseDefaultSelectedAddress(suggestedAddresses) {
  return suggestedAddresses.length > 0 ? suggestedAddresses[0] : null;
}